
import Navbar from '../../components/feature/Navbar';
import PolicyHero from './components/PolicyHero';
import PolicyAuthority from './components/PolicyAuthority';
import PolicyTimeline from './components/PolicyTimeline';
import PolicyRules from './components/PolicyRules';
import PolicyComparison from './components/PolicyComparison';
import PolicyFAQ from './components/PolicyFAQ';
import PolicyCTA from './components/PolicyCTA';

const PolicyPage = () => {
  return (
    <div className="min-h-screen">
      {/* 导航栏 */}
      <Navbar />
      
      {/* 首屏价值主张区 */}
      <PolicyHero />
      
      {/* 政策权威背书区 */}
      <PolicyAuthority />
      
      {/* 政策发展时间轴 */}
      <PolicyTimeline />
      
      {/* 1039核心规则拆解 */}
      <PolicyRules />
      
      {/* 与其他出口模式对比 */}
      <PolicyComparison />
      
      {/* 高频误区与监管关注点 */}
      <PolicyFAQ />
      
      {/* 行动引导区 */}
      <PolicyCTA />
    </div>
  );
};

export default PolicyPage;
